import Vue from 'vue';
import Router from 'vue-router';
import { Dashboard, Analytics } from '@/pages/dashboard';
import { Login } from '@/pages/login';
import { Cities } from '@/pages/cities';
import { hotel } from '@/pages/hotel';
import { Products } from '@/pages/products';
import { Records } from '@/pages/records';
import { Hotels } from '@/pages/hotels';
import { Users } from '@/pages/users';
import { Queries } from '@/pages/quries';
import { Bookings } from '@/pages/bookings';
import { Settings } from '@/pages/settings';

import Firebase from '../lib/Firebase';

Vue.use(Router);

const router = new Router({
  
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/app',
      name: 'Dashboard',
      component: Dashboard,
      children: [
        {
          path: '/app/analytics',
          name: 'Analytics',
          component: Analytics
        },
        {
          path: '/app/cities',
          name: 'Cities',
          component: Cities
        },
        {
          path: '/app/hotel',
          name: 'Hotel',
          component: hotel
        },
        {
          path: '/app/products',
          name: 'Products',
          component: Products
        },
        {
          path: '/app/records',
          name: 'Records',
          component: Records
        },
        {
          path: '/app/hotels',
          name: 'Hotels',
          component: Hotels
        },
        {
          path: '/app/users',
          name: 'Users',
          component: Users
        },
        {
          path: '/app/queries',
          name: 'Queries',
          component: Queries
        },
        {
          path: '/app/bookings',
          name: 'Bookings',
          component: Bookings
        },
        {
          path: '/app/configs',
          name: 'Settings',
          component: Settings
        },
      
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    next();
  }

  Firebase.auth().onAuthStateChanged(user => {
    if (!user) {
      next('/');
    } else {
      next();
    }
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js